export const isPatient = (role) => {
    return role==='Patient';    
}